import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import OutlinedButton from "../Form/OutlinedButton";
import CustomButton from "../Form/CustomButton";

export const AboutBody = () => {
  return (
    <React.Fragment>
      <Grid container spacing={2} className=" bg-white h-fit md:py-20">
        <Grid item xs={12} sm={12} md={8} className="relative  md:h-[800px] ">
          <Box className="md:absolute right-1 z-10 ">
            <img
              src="SBD/CEO-SBD.jpg"
              //   src={imgSrc}
              alt={"about us"}
              className=" -mt-4 object-cover w-full md:w-[600px] md:h-[700px] h-[300px]" //drop-shadow-md
              //   h-[400px] w-[500px] object-cover
            />
          </Box>
          <Box className=" h-[500px] w-[400px] md:absolute opacity-95 bg-white md:shadow-md md:drop-shadow-md top-32 md:left-32 lg:left-52 z-30">
            <Box className=" grid justify-end p-8 text-end gap-3">
              <Typography
                variant="h1"
                fontWeight={400}
                fontSize={{ xs: "12px", sm: "15px", md: "15px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color="secondary"
                className=" uppercase"
              >
                About Us
              </Typography>
              <Typography
                variant="h3"
                // fontWeight={800}
                fontSize={{ xs: "25px", sm: "30px", md: "35px" }}
                lineHeight={{ xs: "110%", sm: "120%" }}
                letterSpacing={"-0.05em"}
                color="primary"
                className=" pb-6"
              >
                Elevate your style with our hair products
              </Typography>

              <Typography
                variant="subtitle"
                fontSize={{ xs: "14px", sm: "14px", md: "14px" }}
                lineHeight={{ xs: "185%", sm: "160%" }}
                letterSpacing={"-0.02em"}
                color={"primary"}
                className=" opacity-60"
              >
                Embrace confidence with ethically sourced, high quality hair
                that seamlessly integrates into your lifestyle, making every day
                a fabulous hair day.
              </Typography>

              <CustomButton
                type="submit"
                // form="add-member-form"
                //   loading={true}
                sx={{ width: "200px", height: "55px" }}
                color="primary"
                className="!text-base !uppercase !mt-10"
                //   onClick={handleSubmit}
                to={"/contact"}
                // fullWidth
              >
                Contact Us
              </CustomButton>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          className=" flex items-center justify-center"
        >
          <Box className=" grid gap-10 w-[80%]">
            <Box className="">
              <Typography
                variant="h3"
                // fontWeight={800}
                fontSize={{ xs: "25px", sm: "30px", md: "35px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color="primary"
                className=" pb-2"
              >
                Our Mission
              </Typography>
              <Typography
                variant="subtitle"
                fontSize={{ xs: "14px", sm: "14px", md: "14px" }}
                lineHeight={{ xs: "185%", sm: "160%" }}
                letterSpacing={"-0.02em"}
                color={"primary"}
                className=" opacity-50"
              >
                Transforming confidence through beautiful hair. We aim to
                empower individuals by providing high quality, ethically sourced
                hair products that enhance natural beauty. Our mission is to
                redefine standards in the hair industry, promoting self
                expression and self assurance for every customer.
              </Typography>
            </Box>
            <Box className="">
              <Typography
                variant="h3"
                // fontWeight={800}
                fontSize={{ xs: "25px", sm: "30px", md: "35px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color="primary"
                className=" pb-2"
              >
                Business Goals
              </Typography>
              <Typography
                variant="subtitle"
                fontSize={{ xs: "14px", sm: "14px", md: "14px" }}
                lineHeight={{ xs: "185%", sm: "160%" }}
                letterSpacing={"-0.02em"}
                color={"primary"}
                className=" opacity-50"
              >
                Striving for excellence, our goals include revolutionizing the
                online hair market with trend setting products, exceptional
                customer service, and sustainable practices. We aspire to be a
                global leader, fostering a community where customers can trust
                our brand for unparalleled quality and style in every hair
                purchase.
              </Typography>
            </Box>
            <CustomButton
              type="submit"
              sx={{ width: "200px", height: "55px" }}
              color="secondary"
              className="!text-base !uppercase !mt-10"
              to={"/shop"}
            >
              Go to shop
            </CustomButton>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
